import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { FaUsers, FaChartBar, FaBell } from 'react-icons/fa';
import UserManagement from './UserManagement';
import AdminStats from './AdminStats';
import SendNotification from './SendNotification';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname.includes(path);
  };

  return (
    <div className="admin-dashboard">
      <div className="container">
        <div className="admin-header">
          <h1>Admin Dashboard</h1>
          <p>Manage users, view statistics, and send notifications</p>
        </div>

        <div className="admin-layout">
          <aside className="admin-sidebar">
            <nav className="admin-nav">
              <Link 
                to="/admin/stats" 
                className={`admin-nav-item ${isActive('stats') ? 'active' : ''}`}
              >
                <FaChartBar /> Statistics
              </Link>
              <Link 
                to="/admin/users" 
                className={`admin-nav-item ${isActive('users') ? 'active' : ''}`}
              >
                <FaUsers /> User Management
              </Link>
              <Link 
                to="/admin/notifications" 
                className={`admin-nav-item ${isActive('notifications') ? 'active' : ''}`}
              >
                <FaBell /> Send Notifications
              </Link>
            </nav>
          </aside>

          <main className="admin-content">
            <Routes>
              <Route path="stats" element={<AdminStats />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="notifications" element={<SendNotification />} />
              <Route path="/" element={<AdminStats />} />
            </Routes>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
